import { Button } from '@eureca/ui';
import { ConsultantsMenu } from '@/shared/consultants-menu/ConsultantsMenu';
import { CheckIcon } from './icons';

export interface ProgramEditSuccessPageProps {
  /** Called when user clicks "Criar vaga" (Figma 6). */
  onCreateJob: () => void;
  onBackToPrograms: () => void;
}

export function ProgramEditSuccessPage({
  onCreateJob,
  onBackToPrograms,
}: ProgramEditSuccessPageProps) {
  return (
    <div className="flex min-h-dvh flex-row bg-muted">
      <ConsultantsMenu activeId="programs" />

      <main className="flex flex-1 flex-col items-center justify-center gap-8 bg-card px-8 py-16">
        <section
          aria-live="polite"
          className="flex w-full max-w-[640px] flex-col items-stretch gap-5"
        >
          <div className="flex flex-col items-center gap-5">
            <div
              aria-hidden
              className="flex size-16 items-center justify-center rounded-full bg-secondary text-primary"
            >
              <CheckIcon className="size-6" />
            </div>
            <h1 className="text-center text-4xl font-medium leading-none tracking-tight text-foreground">
              Programa editado com sucesso
            </h1>
          </div>

          <div className="flex flex-row justify-center gap-2 pt-3">
            <Button variant="outline" onClick={onBackToPrograms}>
              Conferir programas
            </Button>
            <Button onClick={onCreateJob}>Criar vaga</Button>
          </div>
        </section>
      </main>
    </div>
  );
}
